import CrudPage from "./CrudPage";

const Events = () => (
  <CrudPage
    title="Events"
    resource="events"
    testId="admin-events"
    columns={[
      { key: "title", label: "Titel" },
      { key: "date", label: "Datum" },
      { key: "location", label: "Ort" },
      { key: "type", label: "Art" },
      { key: "status", label: "Status" },
    ]}
    fields={[
      { key: "title", label: "Titel", required: true },
      { key: "description", label: "Beschreibung", type: "textarea", full: true },
      { key: "date", label: "Datum", type: "date", required: true },
      { key: "time", label: "Uhrzeit" },
      { key: "location", label: "Ort", required: true },
      { key: "type", label: "Eventart", type: "select", options: [
        { value: "jahreskonzert", label: "Jahreskonzert" },
        { value: "kulturveranstaltung", label: "Kulturveranstaltung" },
        { value: "talent_show", label: "Talent Show" },
        { value: "workshop_event", label: "Workshop Event" },
        { value: "festival", label: "Festival" },
        { value: "wettbewerb", label: "Wettbewerb" },
      ]},
      { key: "registration_open", label: "Anmeldung möglich", type: "boolean" },
      { key: "status", label: "Status", type: "select", options: [{ value: "planned", label: "Geplant" }, { value: "done", label: "Abgeschlossen" }] },
      { key: "image", label: "Bild URL", full: true },
    ]}
    defaults={{ title: "", description: "", date: "", time: "", location: "", type: "jahreskonzert", registration_open: true, status: "planned", image: "", gallery: [] }}
  />
);

export default Events;
